import Swiper from 'swiper';
import { Pagination, Thumbs } from 'swiper/modules';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { dataBackgound } from './pathToWebp.js'
import Swal from 'sweetalert2'
import '../sass/games_detail.sass';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { 
    faAngleRight,
    faAngleLeft,
    // 以下共用
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { 
    faApple,
    faAndroid,
    faWindows,
    faHtml5,
    // 以下共用
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'
library.add(
    faAngleRight, 
    faAngleLeft, 
    faApple, 
    faAndroid, 
    faWindows,
    faHtml5,
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,)
dom.watch()



$(function() {

    //第一塊進場動畫
    $('.game_detail_block').addClass('moveIn')
    let url = location.href,
        locaSide = "127.0.0.1:5500",
        afterPath = "../"
    if (url.split(locaSide).length > 1) {
        afterPath = "http://192.168.30.242:6090/"
    }

    for (var i = 0; i < $('video').length; i++) {
        let oPath = $('video source').attr("data-src")
        $('video').eq(i).attr("src", afterPath + oPath)
    }


    var thumbsSlider = new Swiper('.thumbsSlider ', {
        slidesPerView: 3,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3,
        },
        loop: true,
        grabCursor: true,

    });

    var swiper = new Swiper('.p-detail-swiper .swiper-container ', {
        slidesPerView: 'auto',
        loopedSlides: 10,
        spaceBetween: 10,
        speed: 1000,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3,
        },
        watchSlidesVisibility: true,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        grabCursor: true,
        pagination: {
            el: '.p-detail-swiper .swiper-pagination',
            clickable: true,
        },
        modules: [Pagination, Thumbs],
        thumbs: {
            swiper: thumbsSlider,
        },
        on: {
            beforeInit: dataBackgound,
            init: function(swiper) {
                if ($('.swiper-slide-active video').length > 0) {
                    //先把所有影片停止
                    $('.swiper-slide-active video').get(0).pause()
                    $('.swiper-slide-active video').get(0).currentTime = 0
                }
            },
            slideChange: function() {
                $('.swiper-slide').find('video').each(function() {
                    this.pause();
                    this.currentTime = 0
                });
            },
            slideChangeTransitionEnd: function() {
                if ($('.swiper-slide-active video').length > 0) {
                    $('.swiper-slide-active video').get(0).play()
                }
            },

        },

    });

    var swiperMobile = new Swiper('.mb_slider .swiper-container ', {
        speed: 1000,
        spaceBetween: 20,
        loop: false,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
            el: '.mb_slider .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            575: {
                spaceBetween: 30,
            },
        },
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 3,
        },

    })
    
    const lg = document.querySelector(".p-detail-swiper .swiper-container");

    lg.addEventListener('lgBeforeSlide', (event) => {
        const { index, prevIndex } = event.detail;
        if(index !== prevIndex) swiper.slideToLoop(index);
    });

    lightGallery(lg, {
        speed: 500,
        showZoomInOutIcons: true,
        download: false,
        height: '80%',
        width: '80%',
        actualSize: false,
        controls: true,
        selector: '.swiper-slide > a',
        plugins: [lgZoom]
      });


    
    $(".video-btn").on("click", function() {
        const youtubeCode = $(".video-btn").data("link")
        Swal.fire({
            html: `
            <img src="https://i.ytimg.com/vi_webp/${youtubeCode}/maxresdefault.webp" />
            <iframe src="https://www.youtube.com/embed/${youtubeCode}?si=Gc4FkcBTz_eIcPvp" 
              title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' 
              allowfullscreen></iframe>
            `,
            customClass: {
                container: 'youtubeIframe',
            },
            showConfirmButton: false,
          });
    });

})